import { Routes } from '@angular/router';
import { LayoutComponent } from './layout/layout.component';

export const routes: Routes = [
  {
    path: '',
    component: LayoutComponent,
    children: [
      {
        path: '',
        redirectTo: 'executive-summary',
        pathMatch: 'full'
      },
      {
        path: 'executive-summary',
        loadComponent: () => import('./executive-summary/executive-summary.component')
          .then(m => m.ExecutiveSummaryComponent)
      },
      {
        path: 'hse-report',
        loadComponent: () => import('./hse-report/hse-report.component')
          .then(m => m.HSEReportComponent)
      },
      {
        path: 'operations-overview',
        loadComponent: () => import('./operation-analysis/operation-analysis.component')
          .then(m => m.OperationAnalysisComponent)
      },
      {
        path: 'databricks',
        loadComponent: () => import('./databricks/databricks.component')
          .then(m => m.DatabricksComponent)
      },
      {
        path: 'genie',
        loadComponent: () => import('./genie/genie.component')
          .then(m => m.GenieComponent)
      }
    ]
  },
  {
    path: '**',
    redirectTo: 'executive-summary'
  }
];